const showUpload = (
  onBrowse: (files: FileList | null) => Promise<void>,
  type = "file",
  accept = ".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
) => {
  const input = document.createElement("input");
  input.setAttribute("type", type);
  input.setAttribute("accept", accept);
  input.setAttribute("multiple", "true");
  input.addEventListener("change", () => {
    onBrowse(input.files);
  });
  input.dispatchEvent(new MouseEvent("click"));
};

const useUpload = () => {
  return {
    showUpload,
  };
};

export default useUpload;
